import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddressForm from 'components/AddressForm';
import StyledTextField from 'ui/StyledComponents/StyledTextField';

import { handleValidation } from './handleValidation';

import Button from 'ui/Button';
import FormSection from 'ui/FormSection';

import { useError } from 'utils/useErrorController';

import { t } from 'i18n/index';

const emptyAddress = {
  name: '',
  address: '',
  city: '',
  post_code: '',
  country: '',
};

// SELL05 — one shipping address per order, asked before the payment step when
// any purchased item is deliverable.
const ShippingAddressForm = ({ onSubmit }) => {
  const [addressData, setAddressData] = useState(emptyAddress);
  const { loading, validate, handleError } = useError();

  const handleChange = ({ target: { name, value } }) => {
    setAddressData({ ...addressData, [name]: value });
  };

  const handleSubmit = (e) => {
    try {
      e.preventDefault();
      validate(addressData, handleValidation, true);
      onSubmit(addressData);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
      <FormSection title={t('shippingForm:title')} slim>
        <div>
          <p>{t('shippingForm:hint')}</p>
          <p>{t('shippingForm:noExtraCosts')}</p>
        </div>
        <StyledTextField
          label={t('shippingForm:recipientName')}
          name='name'
          value={addressData.name || ''}
          onChange={handleChange}
          fullWidth
          size='small'
          color='warning'
        />
      </FormSection>

      <AddressForm
        onChange={handleChange}
        data={addressData}
        onDataChange={setAddressData}
        end_user={true}
      />

      <Button fullwidth loading={loading} onClick={handleSubmit} highlighted>
        {t('literal:continue')}
      </Button>
    </div>
  );
};

ShippingAddressForm.propTypes = {
  onSubmit: PropTypes.func,
};

export default ShippingAddressForm;
